import React, { useState, useEffect } from "react";
import "./style/modalGraphics.css";
import server, { endpoints } from "../../../utils/server";
import '../../expos/styles/eventDetails.css';
import Chart from "react-apexcharts";
import {CloseOutlined} from "@ant-design/icons"
import {message } from "antd";

const ModalGraphics = ({ idCycle, eventName, eventId }) => {
  const [userScolarship, setUserScolarship] = useState([]);
  const [teamsData, setTeamsData] = useState([{}]);
  const [attendanceData, setAttendanceData] = useState([{}]);
  //const [series, setSeries] = useState([{}]);


  const options = {
    chart: {
      id: "donut-chart",
      type: "donut",
    },
    title: {
      align: 'center',
      style: { fontSize: '20px', fontWeight: 'bold', color: '#333' }
  },
  name: {
    show: false
  },

    labels: ["Asistentes", "Ausentes"],
    colors: ['#46C16C', '#D92626'],
    stroke: { width: 2, colors: ['#fff'], lineCap: 'round' },
    plotOptions: {
      pie: {
        donut: {
          size: '88%',
          labels: {
            show: true,
            total: {
                show: true,
                label: 'Asistentes',
                color:'#46C16C'
            },
            
          }
        }
      }
      
    },
    legend: { show: false },
      dataLabels: { enabled: false },
      responsive: [{ breakpoint: 480, options: { chart: { width: 300 } } }]
  };

    useEffect(() => {
      getAttendancePerEvent();
    }, []);
  

   const getAttendancePerEvent = async () => {

    const res = await server(
      endpoints.getAttendancePerEvent.route,
      endpoints.getAttendancePerEvent.method,
      { id_cycle: idCycle , id_department_event: eventId},
    );

    const { error_message, data: teamsData } = res;
    if (res.error_message) {
      message.error(res.error_message);
    } else {
      setAttendanceData(teamsData.realAttendanceTeams);
      setTeamsData(teamsData.attendanceTeams);
      
    }
  };

  return (
    <div className="modalContainer">
      <h2>Asistencias al Evento {eventName}</h2>
      <div className="chart-grid">
        {teamsData.map((item, i) => (
          <div className={`chart-item chart-${i < 3 ? "top" : "bottom"}`} >
            <Chart
  options={{
    ...options,
    title: {
      ...options.title,
      text: item.name
    },
    plotOptions: {
      ...options.plotOptions,
      pie: {
        ...options.plotOptions.pie,
        donut: {
          ...options.plotOptions.pie.donut,
          labels: {
            ...options.plotOptions.pie.donut.labels,
            total: {
              ...options.plotOptions.pie.donut.labels.total,
              formatter: () => {
                const total = item.total_users_per_team;
                
                const percentage = total === 0 ? 0 : ((attendanceData[i].attendance_count / total) * 100).toFixed(1);
                return `${percentage}%`;
              }
            }
          }
        }
      }
    }
  }}
  series={[attendanceData[i].attendance_count, item.total_users_per_team - attendanceData[i].attendance_count]}
  type="donut"
  width="100%"
  height={250}
/>
<div className="eventDetails-legend">
                        <h2>Total</h2>
                        <div className="legend-item">
                            <span className="legend-color" style={{ backgroundColor: '#28a745' }}></span>
                            <span>Asistentes</span>
                            <span className="legend-value">{attendanceData[i].attendance_count}</span>
                        </div>
                        <div className="legend-item">
                            <span className="legend-color" style={{ backgroundColor: '#dc3545' }}></span>
                            <span>Ausentes</span>
                            <span className="legend-value">{ item.total_users_per_team - attendanceData[i].attendance_count}</span>
                        </div>
                    </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ModalGraphics;

